import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

export const CoveringFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['hours']}
            availableFilterOperations={['greaterThanOrEqual', 'lessThanOrEqual']}
        />
    );
};

export const CourseFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['numBookings']}
            availableFilterOperations={['greaterThanOrEqual', 'lessThanOrEqual']}
        />
    );
};

export const TeacherFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['numCourses']}
            availableFilterOperations={['greaterThanOrEqual', 'lessThanOrEqual']}
        />
    );
};

export const InternalHoursFilterOperations = () => {
    return <DataTypeProvider for={['hours']} availableFilterOperations={['greaterThanOrEqual', 'lessThanOrEqual']} />;
};

export const SkillsFilterOperations = () => {
    return <DataTypeProvider for={['skills']} availableFilterOperations={['contains']} />;
};

export const BirthDateFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['birthDate']}
            availableFilterOperations={['startsWith', 'greaterThanOrEqual', 'lessThanOrEqual', 'equal', 'notEqual']}
        />
    );
};

export const StartDateFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['startDate']}
            availableFilterOperations={['startsWith', 'greaterThanOrEqual', 'lessThanOrEqual', 'equal', 'notEqual']}
        />
    );
};

export const EndDateFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['endDate']}
            availableFilterOperations={['startsWith', 'greaterThanOrEqual', 'lessThanOrEqual', 'equal', 'notEqual']}
        />
    );
};

export const OfficeFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['totalEmployees', 'totalConsultants']}
            availableFilterOperations={['greaterThanOrEqual', 'lessThanOrEqual']}
        />
    );
};

export const InvoiceHoursFilterOperations = () => {
    return <DataTypeProvider for={['latestInvoiceAmount']} availableFilterOperations={['greaterThanOrEqual', 'lessThanOrEqual']} />;
};

export const LatestInvoiceMonthFilterOperations = () => {
    return (
        <DataTypeProvider
            for={['latestInvoiceMonth']}
            availableFilterOperations={['greaterThanOrEqual', 'lessThanOrEqual', 'equal', 'notEqual']}
        />
    );
};
